import { startOf, endOf } from 'shared/LuxonHelpers'
import { useSelector } from 'react-redux'
const CrewFilter = (data, filter, timezone) => {
  const {
    displaySafeCare,
    filterBlockhours,
    filterNightsAway,
    filterBlockhoursWithPreAssignments,
    filterScore,
    searchFlight,
    searchFlightNumber,
    searchActivityCode,
    searchPlCode,
    searchSpecialCode,
    issueEmployeeCode,
    searchHomeBase,
    searchSecondBase,
    includeSecondBase,
    searchFunction,
    searchQualifications,
    searchAirportQualifications,
    filterIssueType,
    filterSeverityWarning,
    filterSeverityError,
    filterSeverityBlocking,
    filterIgnoredPreAssignedPairingIssues,
    filterTypeOfActivity,
    filterCrewOnFlightId,
    selectedDay,
  } = filter

  let t0 = 0
  let t1 = 36000000000000

  if (selectedDay) {
    t0 = startOf(selectedDay, timezone, 'day')
    t1 = endOf(selectedDay, timezone, 'day')
  }

  let c = data.slice()

  // filter Crew Id
  if (searchPlCode.length) {
    c = data.filter((d) => searchPlCode.includes(d.employeeCode))
  }

  // filter Home Base
  if (searchHomeBase.length) {
    c = c.filter((i) => searchHomeBase.includes(i.homeBase))
  }

  // filter Second Base
  if (searchSecondBase.length) {
    c = c.filter((i) => i.contractBase.some((val) => searchSecondBase.includes(val.slice(0, 3))))
  }

  // filter based on Crew Function
  if (searchFunction.length) {
    c = c.filter((i) => searchFunction.includes(i.crewFunction) || i.crewFunction.toLowerCase() === 'plane')
  }

  // filter based on Qualifications
  if (searchQualifications.length > 0) {
    c = c.filter(
      (i) =>
        searchQualifications.some((r) => i.aircraftQualifications.map((d) => d.qualificationCode).includes(r)) ||
        i.crewFunction.toLowerCase() === 'plane'
    )
  }
  // filter based on Airport Qualifactions
  if (searchAirportQualifications.length > 0) {
    c = c.filter(
      (i) =>
        searchAirportQualifications.some((r) => i.airportQualifications.map((d) => d.airport).includes(r)) ||
        i.crewFunction.toLowerCase() === 'plane'
    )
  }
  if (searchFlight?.length > 0) {
    //filter data
    c = c.filter((d) =>
      d.activities.some((a) => {
        if (a.from && a.to && a.flightNumber)
          return (
            a.startTime >= t0 && a.endTime <= t1 + 1 && (a.from + '-' + a.to).indexOf(searchFlight.toUpperCase()) >= 0
          )
        return false
      })
    )
  }

  if (filterTypeOfActivity.length) {
    c = c.filter(
      (d) =>
        d.activities?.some(
          (a) => a.endTime >= t0 && a.endTime <= t1 + 1 && filterTypeOfActivity.includes(a.typeOfActivity)
        ) ||
        d.flight_duties?.some(
          (a) => a.endTime >= t0 && a.endTime <= t1 + 1 && filterTypeOfActivity.includes(a.typeOfActivity)
        ) ||
        d.pairings?.some(
          (a) => a.endTime >= t0 && a.endTime <= t1 + 1 && filterTypeOfActivity.includes(a.typeOfActivity)
        ) ||
        d.crewFunction?.toLowerCase() === 'plane'
    )
  }
  if (displaySafeCare) {
    if (filterScore > 1)
      c = c.filter((d) => {
        return d.safeCare.maximumFatigue >= filterScore
      })
  }

  const typeActual = filterBlockhoursWithPreAssignments ? 'actualWithPreAssignments' : 'actual'
  const typeTarget = filterBlockhoursWithPreAssignments ? 'targetWithPreAssignments' : 'target'

  if (filterBlockhours.enabled) {
    c = c.filter((d) => {
      const v = d.equalDistributionMetrics?.blockHoursTotal?.[typeActual] || 0
      return filterBlockhours.range[0] <= v && v <= filterBlockhours.range[1]
    })

    if (filterBlockhours.targetEnabled) {
      c = c.filter((d) => {
        const delta =
          d.equalDistributionMetrics?.blockHoursTotal?.[typeTarget] -
            d.equalDistributionMetrics?.blockHoursTotal?.[typeActual] || 0
        if (filterBlockhours.target < 0 && delta < filterBlockhours.target) return true
        if (filterBlockhours.target > 0 && delta > filterBlockhours.target) return true
        if (filterBlockhours.target === 0 && delta === 0) return true
        return false
      })
    }
  }
  if (filterNightsAway.enabled) {
    c = c.filter((d) => {
      const v = d.equalDistributionMetrics?.hotelStaysTotal?.[typeActual] || 0
      return filterNightsAway.range[0] <= v && v <= filterNightsAway.range[1]
    })
    if (filterNightsAway.targetEnabled) {
      c = c.filter((d) => {
        const delta =
          d.equalDistributionMetrics?.hotelStaysTotal?.[typeTarget] -
            d.equalDistributionMetrics?.hotelStaysTotal?.[typeActual] || 0
        if (filterNightsAway.target < 0 && delta < filterNightsAway.target) return true
        if (filterNightsAway.target > 0 && delta > filterNightsAway.target) return true
        if (filterNightsAway.target === 0 && delta === 0) return true
        return false
      })
    }
  }
  if (filterCrewOnFlightId) {
    c = c.filter(
      (el) => el.crewFunction === 'Plane' || el.activities.some((e) => e.activityID === filterCrewOnFlightId)
    )
  }

  // Search for flight number
  if (searchFlightNumber?.length > 0) {
    c = c.filter((d) =>
      d.activities.some((a) => {
        return (
          a.startTime >= t0 &&
          a.endTime <= t1 + 1 &&
          searchFlightNumber.map((d) => d.toUpperCase()).includes(a.flightNumber?.toUpperCase())
        )
      })
    )
  }

  if (searchSpecialCode?.length > 0) {
    c = c.filter((d) => d.specialFunctionsAtStartOfPublication.some((s) => searchSpecialCode.includes(s)))
  }

  if (searchActivityCode?.length > 0) {
    c = c.filter((d) =>
      d.activities.some((a) => {
        return (
          ((a.startTime >= t0 && a.startTime <= t1 + 1) || (a.endTime >= t0 && a.endTime <= t1 + 1)) &&
          (searchActivityCode.includes(a.standByCode) || searchActivityCode.includes(a.activityCode))
        )
      })
    )
  }

  if (filterIgnoredPreAssignedPairingIssues) {
    c = c.filter((d) => d.issues.some((i) => i.issueType === 'IgnoredPreAssignedPairing'))
  } else if (filterIssueType.length > 0)
    c = c.filter((d) => {
      let curatedIssueTypes = filterIssueType.slice()
      const i = curatedIssueTypes.findIndex((d) => d === 'FlightCoverageIssue')
      if (i >= 0) curatedIssueTypes.splice(i, 1)

      if (curatedIssueTypes?.length > 0) {
        return d.issues.some((i) => curatedIssueTypes.includes(i.issueType))
      }
      return true
    })

  if (filterSeverityBlocking || filterSeverityWarning || filterSeverityError)
    c = c.filter((d) =>
      d.issues.some(
        (i) =>
          (filterSeverityBlocking && i.severity === 'blocking') ||
          (filterSeverityWarning && i.severity === 'warning') ||
          (filterSeverityError && i.severity === 'error')
      )
    )

  return c.map((d, i) => {
    return { ...d, odd: i % 2 }
  })
}

export default CrewFilter
